import { useTranslation } from 'react-i18next';

import { ContentBlock } from '~/components/molecules/ContentBlock';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { PollStats } from '~/components/organisms/PollStats';
import { PollVoteList } from '~/components/organisms/PollVoteList';
import { usePollQuery } from '~/lib/api/modules/Polls/hooks/usePollQuery';

export type IPollProps = {
  appId: string;
  pollId: string;
};

export const Poll: React.FC<IPollProps> = (props) => {
  const { appId, pollId } = props;
  const pollQuery = usePollQuery({
    appId,
    pollId,
  });
  const { t } = useTranslation();

  const poll = pollQuery.data;

  return (
    <>
      {pollQuery.isError ? (
        <ContentBlock>
          <ContentBlock.Body first>
            <ErrorMessage error={pollQuery.error} />
          </ContentBlock.Body>
        </ContentBlock>
      ) : pollQuery.isLoading ? (
        <ContentBlock>
          <ContentBlock.Body first>
            {/* TODO: use skeletons */}
            {t('common.loading')}
          </ContentBlock.Body>
        </ContentBlock>
      ) : (
        poll && (
          <>
            <PollStats appId={appId} pollId={pollId} />
            <PollVoteList appId={appId} pollId={pollId} />
          </>
        )
      )}
    </>
  );
};
